import type { ReactNode } from 'react';

export const symbol_desk: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M80-270v-390q0-24.75 17.63-42.38Q115.25-720 140-720h680q24.75 0 42.38 17.62Q880-684.75 880-660v390q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-70H630v70q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-390H140v390q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q80-257.25 80-270Zm550-290h190v-100H630v100Zm0 160h190v-100H630v100Z"
		/>
	</svg>
);
